import React, {useState} from "react";
import PageName from "../../components/PageName";
import RSATable from "../../components/RSA/RSATable";
import RSAForm from "../../components/RSA/RSAForm";
import RSAPreview from "../../components/RSA/RSAPreview";
import SuccessModal from "../../components/SuccessModal";
import TimeOutActivityLayout from "../auth/inactivity-timeout-v2";

const TransferRSA = () => {
    const [showTransferSuccess, setShowTransferSuccess] = useState(false);
    const [showFormPage, setShowFormPage] = useState(false);
    const [isFormCompleted, setFormCompleted] = useState(false);

    const toggleShowFormPage = () => setShowFormPage(!showFormPage);
    const toggleIsFormCompleted = () => setFormCompleted(!isFormCompleted);
    const toggleShowTransferSuccess = () => setShowTransferSuccess(!showTransferSuccess);

    const resetAll = () => {
        setShowFormPage(false);
        setFormCompleted(false);
        setShowTransferSuccess(false);
    }

    return (

        <TimeOutActivityLayout>
        <div className="transaction-page">
            <SuccessModal
                showModal={showTransferSuccess}
                onClose={resetAll}
                note={"Your RSA transfer has been submitted successfully."}
            />
            <PageName pageName={"Refer and Reward"} />
            { !showFormPage ?
                <RSATable onClickMainButton={toggleShowFormPage} isTransfer />
                :
                    !isFormCompleted ?
                        <RSAForm onClose={toggleShowFormPage} onTransferSuccess={toggleShowTransferSuccess} isTransfer/>
                        :
                        <RSAPreview onBack={toggleIsFormCompleted} onClose={resetAll} />
            }
        </div>
        </TimeOutActivityLayout>
    )
}
export default TransferRSA;